module.exports = __webpack_public_path__ + "img/sosial.abe635b6.png";